import React from "react";
import { Play, ExternalLink } from "lucide-react";

const TRACKS = [
  {
    n: "01",
    title: "Es geht dir gut",
    year: "2026 · Neue Single",
    desc: "Die brandneue Single — ein Song voller Emotionen und moderner Beats. Ab sofort überall erhältlich.",
    spotify: "https://open.spotify.com/artist/2KSTe6bHvOVnotewpdelFI?si=ZawMDcGhS5uCguDCCkpTcA",
    apple: "https://music.apple.com/de/artist/daniel-lopes/40701009",
    youtube: "https://youtube.com/@daniellopesofficial?si=uqxnLH6SQcuyW2FA",
    featured: true,
    badge: "Aktuell",
  },
  {
    n: "02",
    title: "Ich kann für nichts garantieren",
    year: "Duett mit Pia Sophie",
    desc: "Platz 1 der konservativen Airplay-Charts. Die Schlager-Hymne, die ganze Säle in Bewegung bringt.",
    spotify: "https://open.spotify.com/artist/2KSTe6bHvOVnotewpdelFI?si=ZawMDcGhS5uCguDCCkpTcA",
    apple: "https://music.apple.com/de/artist/daniel-lopes/40701009",
    youtube: "https://youtube.com/@daniellopesofficial?si=uqxnLH6SQcuyW2FA",
    featured: true,
    badge: "Radio-Hit · Nr. 1 Airplay",
  },
  {
    n: "03",
    title: "Shine On",
    year: "2003 · Der Klassiker",
    desc: "Die Hit-Single, die alles startete — direkt in den Top 10. Bis heute ein Live-Highlight, das Generationen verbindet.",
    spotify: "https://open.spotify.com/artist/2KSTe6bHvOVnotewpdelFI?si=ZawMDcGhS5uCguDCCkpTcA",
    apple: "https://music.apple.com/de/artist/daniel-lopes/40701009",
    youtube: "https://youtube.com/@daniellopesofficial?si=uqxnLH6SQcuyW2FA",
    featured: true,
    badge: "The Classic",
  },
];

export default function Music() {
  return (
    <section
      id="musik"
      data-testid="music-section"
      className="relative bg-[#0F0F0F] py-24 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <p className="overline" data-testid="music-overline">
              <span className="gold-rule mr-4 align-middle" />
              Diskografie · Aktuelle Releases
            </p>
            <h2
              className="font-display mt-4 text-white leading-tight tracking-tight"
              style={{ fontSize: "clamp(2.4rem, 5vw, 4rem)", fontWeight: 600 }}
              data-testid="music-headline"
            >
              Neue Single.
              <br />
              <span className="italic text-[#D4AF37]">„Es geht dir gut."</span>
            </h2>
          </div>
          <p className="text-[#A3A3A3] max-w-md font-body text-base leading-relaxed">
            Vom Streaming-Erfolg bis zur Liveshow: Vom 2003er-Hit „Shine On"
            bis zum aktuellen Nr.-1-Airplay-Duett mit Pia Sophie — Daniel
            Lopes' Repertoire ist kuratiert für maximale Wirkung.
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5"
          data-testid="music-grid"
        >
          {TRACKS.map((t) => (
            <article
              key={t.n}
              data-testid={`music-track-${t.n}`}
              className={`relative bg-[#0F0F0F] p-8 md:p-12 group lift-card ${
                t.featured ? "md:row-span-1" : ""
              }`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-display text-[#D4AF37]/40 text-5xl md:text-6xl leading-none">
                  {t.n}
                </span>
                {t.featured && (
                  <span className="overline border border-[#D4AF37]/40 px-3 py-1">
                    {t.badge || "Hit"}
                  </span>
                )}
              </div>

              <h3
                className="font-display text-2xl md:text-3xl text-white leading-tight mb-3"
                data-testid={`music-track-title-${t.n}`}
              >
                {t.title}
              </h3>
              <p className="text-xs tracking-[0.22em] uppercase text-[#A3A3A3] mb-5">
                Release · {t.year}
              </p>
              <p className="text-[#C9C9C9] font-body text-base leading-relaxed mb-8 max-w-md">
                {t.desc}
              </p>

              <div className="flex flex-wrap items-center gap-3">
                <a
                  href={t.spotify}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`music-spotify-${t.n}`}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-xs tracking-[0.18em] uppercase text-[#C9C9C9] transition-colors"
                >
                  <Play size={12} strokeWidth={1.5} />
                  Spotify
                </a>
                <a
                  href={t.apple}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`music-apple-${t.n}`}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-xs tracking-[0.18em] uppercase text-[#C9C9C9] transition-colors"
                >
                  Apple Music
                </a>
                <a
                  href={t.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`music-youtube-${t.n}`}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-xs tracking-[0.18em] uppercase text-[#C9C9C9] transition-colors"
                >
                  <ExternalLink size={12} strokeWidth={1.5} />
                  YouTube
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
